import { Private } from 'smoothie';

import type { CardWidgetProps } from '../../types/Card';

const CardWidget = ({ url }: CardWidgetProps) => {
    return (
        <Private flex={1}>
            <iframe
                src={url}
                title="Card Widget"
                frameBorder={0}
                width="100%"
                height="250px"
            />
        </Private>
    );
};

export default CardWidget;
